/** @format */

import template from './gb-loader-overlay.html';
import './gb-loader-overlay.scss';

export const GbLoaderOverlayComponent = {
    template,
    controller: class GbLoaderOverlayComponent {
        constructor($ccLoading) {
            'ngInject';

            this.$ccLoading = $ccLoading;
        }

        isLoading() {
            return this.$ccLoading.isLoading();
        }

        getMessage() {
            let message = this.$ccLoading.getFirstMessage();

            return typeof message === 'function' ? message() : message;
        }
    },
};
